import React, { Component } from 'react';
import { Form, Button, Header, Segment, Icon, Table } from 'semantic-ui-react';
import { paymentType, adjustmentType } from '../../utils/defaults';
import { postAccountPayment } from '../../utils/rest';
import ViewAllocation from './ViewAllocation';
import validation from '../../components/SimpleReactValidation';
import Loading from '../Loading';
class PaymentTab extends Component {
    constructor(props) {
        super(props);
        this.validator = validation();
        this.state = {
            openAllocation: false,
            allocationResult: {},
            paymentAmount: 0,
            adjustmentAmount: 0,
            paymentDate: "",
            adjustmentDate: "",
            paymentType: "",
            adjustmentType: "",
            loading: false
        };
    }

    handleChange = (evt, e) => {
        this.setState({
            [e.name]: e.value
        })
    }

    handleFocus = (event) => event.target.select();
    
    viewAllocation = () => {

        if (this.validator.allValid()) {
            this.setState({
                loading: true
            }, () => {
                let data = {
                    cltClientId: this.props.data[0].cltClientId,
                    conConsumerId: this.props.data[0].conConsumerId,
                    acoAccountId: this.props.data[0].acoAccountId,
                    acoInvoiceId: this.props.data[0].acoInvoiceId,
                    conFirstName: this.props.data[0].conFirstName,
                    conLastName: this.props.data[0].conLastName,
                    paymentAmount: this.state.paymentAmount,
                    paymentDate: this.state.paymentDate,
                    paymentType: this.state.paymentType,
                    adjustmentAmount: this.state.adjustmentAmount,
                    adjustmentDate: this.state.adjustmentDate,
                    adjustmentType: this.state.adjustmentType
                }
                postAccountPayment(this.props.items.currentCorporate, false, data).then((response) => {
                    if (response !== null && response instanceof Object) {
                        this.setState({
                            loading: false,
                            openAllocation: true,
                            allocationResult: response
                        })
                    }
                }).then(() => {
                    this.setState({
                        openAllocation: true,
                        loading: false,
                    })
                })
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    handleSubmit = () => {
        if (this.validator.allValid()) {
            this.setState({
                openAllocation: false
            }, () => {
                let paymentInfo = Object.assign(this.state, this.props.data[0]);
                this.props.handleSubmit(paymentInfo);
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    close = () => {
        this.setState({
            openAllocation: false
        });
    }

    render() {
        if (this.state.loading) {
            return (<Loading />
            )
        }
        const { data } = this.props;
        if (data === null || data.length === 0) {
            return ("No Record Found.")
        }
        return (
            <div>
                <Segment.Group raised>
                    <Segment inverted color="grey">
                        <Header as="h4">
                            <div className="content">
                                Enter a Payment or Adjustment
                            </div>
                        </Header>
                    </Segment>
                    <Segment>
                        <Table attached="top">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell data-inverted="" data-tooltip="Client ID" data-position="top left">Client ID</Table.HeaderCell>
                                    <Table.HeaderCell data-inverted="" data-tooltip="Your Account Number for this Billing" data-position="top left">Client Acct#</Table.HeaderCell>
                                    <Table.HeaderCell data-inverted="" data-tooltip="Our Agency’s Account Number" data-position="top left">Our Acct#: </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Date of Referral" data-position="top center">DOR</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Date Of Service" data-position="top center">DOS</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Date of Last Payment" data-position="top center">DLP</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Current Status of Account" data-position="top center">Status</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Amount Referred" data-position="top center">AR</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Principal Balance" data-position="top center">PB</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Interest" data-position="top center">INT</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Other Charges" data-position="top center">OC</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Currency Code" data-position="top center">Currency Code</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="right" data-inverted="" data-tooltip="Current Total Due" data-position="top right">Total</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign="center">{this.props._ifNull(data[0].cltClientId, "")}</Table.Cell>
                                    <Table.Cell textAlign="center">{this.props._ifNull(data[0].acoInvoiceId, "")}</Table.Cell>
                                    <Table.Cell textAlign="center">{this.props._ifNull(data[0].acoAccountId, "")}</Table.Cell>
                                    <Table.Cell textAlign="center">{this.props._ifNull(data[0].acoDor, "")}</Table.Cell>
                                    <Table.Cell textAlign="center">{this.props._ifNull(data[0].acoDos, "")}</Table.Cell>
                                    <Table.Cell textAlign="center">{this.props._ifNull(data[0].acoDlp, "")}</Table.Cell>
                                    <Table.Cell textAlign="center">{this.props._ifNull(data[0].acoStatusCode, "")}</Table.Cell>
                                    <Table.Cell textAlign="right" >{this.props._currencyFormat(data[0].acoAmountReferred)}</Table.Cell>
                                    <Table.Cell textAlign="right" >{this.props._currencyFormat(data[0].acoPrincipal)}</Table.Cell>
                                    <Table.Cell textAlign="right" >{this.props._currencyFormat(data[0].acoInterest)}</Table.Cell>
                                    <Table.Cell textAlign="right" >{this.props._currencyFormat(data[0].acoOtherCharges)}</Table.Cell>
                                    <Table.Cell textAlign="center" >{this.props._ifNull(data[0].acoIsoCode, "")}</Table.Cell>
                                    <Table.Cell textAlign="right" >{this.props._currencyFormat(data[0].acoTotal)}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                        <Table celled attached={"bottom"}>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell textAlign="right" >Pay Type</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Source (e.g. consumer, insurance, etc.)" data-position="top right">Pay Source</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" data-inverted="" data-tooltip="Date Payment Made" data-position="top right">Pay Date</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="right" data-inverted="" data-tooltip="Amount" data-position="top right">Amount</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign="right" data-inverted="" data-tooltip="Payment" data-position="bottom right">Payment </Table.Cell>
                                    <Table.Cell width={3}><Form.Select placeholder="Select" fluid options={paymentType} name="paymentType" value={this.state.paymentType} onChange={this.handleChange} width={1} /></Table.Cell>
                                    <Table.Cell width={2}>
                                        <div>
                                            <Form.Input name="paymentDate" type="date" fluid value={this.state.paymentDate} onChange={this.handleChange} width={1} />
                                            {this.validator.message('Payment Date', this.state.paymentDate, 'underCurDate|paymentDate:' + this.state.paymentAmount + ',' + this.state.paymentDate)}
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell width={2}>
                                        <div>
                                            <Form.Input name="paymentAmount" fluid value={this.state.paymentAmount} onChange={this.handleChange} width={1} onFocus={this.handleFocus} />
                                            {this.validator.message('Payment Amount', this.state.paymentAmount, 'decimal|amountShouldNotBeLessThanZero:' + this.state.paymentAmount + '|paymentOrAdjustment:' + this.state.paymentAmount + ',' + this.state.adjustmentAmount + '|paymentAmountCheck:' + this.state.paymentAmount + ',' + data[0].acoTotal)}
                                        </div>
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right" data-inverted="" data-tooltip="Adjustment" data-position="bottom right">Adjustment </Table.Cell>
                                    <Table.Cell> <Form.Select placeholder="Select" fluid options={adjustmentType} name="adjustmentType" value={this.state.adjustmentType} onChange={this.handleChange} /></Table.Cell>
                                    <Table.Cell>
                                        <div>
                                            <Form.Input name="adjustmentDate" type="date" fluid value={this.state.adjustmentDate} onChange={this.handleChange} />
                                            {this.validator.message('Adjust Date', this.state.adjustmentDate, 'underCurDate|adjustmentDate:' + this.state.adjustmentAmount + ',' + this.state.adjustmentDate)}
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell>
                                        <div>
                                            <Form.Input name="adjustmentAmount" fluid value={this.state.adjustmentAmount} onChange={this.handleChange} onFocus={this.handleFocus}/>
                                            {this.validator.message('Adjustment', this.state.adjustmentAmount, 'decimal|paymentOrAdjustment:' + this.state.paymentAmount + ',' + this.state.adjustmentAmount + '|paymentAmountCheck:' + this.state.adjustmentAmount + ',' + data[0].acoTotal)}
                                        </div>
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={3} textAlign="right" data-inverted="" data-tooltip="Total after Payment and/or Adjustment" data-position="bottom right"><b>Total</b></Table.HeaderCell>
                                    <Table.HeaderCell textAlign="right" >
                                        <div>
                                            { (parseFloat(data[0].acoTotal) - ((isNaN(parseFloat(this.state.adjustmentAmount)) ? 0 : parseFloat(this.state.adjustmentAmount)) + (isNaN(parseFloat(this.state.paymentAmount)) ? 0 : parseFloat(this.state.paymentAmount)))).toFixed(2)}
                                            {this.validator.message('Total', (parseFloat(data[0].acoTotal) - ((isNaN(parseFloat(this.state.adjustmentAmount)) ? 0 : parseFloat(this.state.adjustmentAmount)) + (isNaN(parseFloat(this.state.paymentAmount)) ? 0 : parseFloat(this.state.paymentAmount)))).toFixed(2), 'required|gte:0')}
                                        </div></Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                    </Segment>
                    <Segment clearing>
                        <Button className="small basic right floated" onClick={this.handleSubmit}>
                            <Icon name="save"></Icon>
                            Submit
                        </Button>
                        <Button className="small basic right floated" onClick={this.viewAllocation} disabled={parseFloat(this.state.paymentAmount) === 0 || this.state.paymentAmount.trim() === ""}>
                            <Icon name="save"></Icon>
                            View Allocation &amp; Submit
                        </Button>
                    </Segment>
                </Segment.Group>
                <ViewAllocation {...this.props} open={this.state.openAllocation} close={this.close} allocation={this.state.allocationResult} handleSubmit={this.handleSubmit} />
            </div>
        );
    }
}
export default PaymentTab;


// WEBPACK FOOTER //
// ./src/app/ui/payments/PaymentTab.js